import BoardListContext from '@/context/apps/board/BoardListContext';
import { useContext } from 'react';

import getFileInfo from '@/utils/getFileInfo';
import { resolveNewsVideo } from '@/utils/newsThumbnail';

import FileInfo from '@/types/fileInfo';

import NewsListItem from './item/NewsListItem';

export default function NesBoardList() {
  const context = useContext(BoardListContext);
  if (!context) {
    throw new Error('Cannot find BoardListContext');
  }
  const { bdData, bcListData, bcNoticeListData } = context;
  return (
    <div>
      {/* 상단 공지사항 */}
      {bdData.notice_take > 0 &&
        bcNoticeListData?.results.slice(0, bdData.notice_take).map((item) => {
          const hasFile =
            bcNoticeListData.file_info?.bc_file &&
            String(item.idx) in bcNoticeListData.file_info.bc_file;

          const fileInfo = getFileInfo({
            file_info: bcNoticeListData.file_info,
            idx: item.idx.toString(),
            fileCategory: 'bc_list_img',
          }) as FileInfo;
          const videoUrl = resolveNewsVideo(
            bcNoticeListData.file_info,
            item.idx,
          );

          return (
            <NewsListItem
              key={item.idx}
              bcIdx={String(item.idx)}
              status={item.status}
              type={item.type}
              writer={item.writer}
              title={item.title}
              url={{
                link: item.link,
                link_status: item.link_status,
                link_target: item.link_target,
              }}
              viewCount={item.count}
              date={item.uploaded_at}
              commentCount={item.comment_count}
              hasFile={hasFile}
              password={item.password}
              showBadge
              imgUrl={fileInfo.file_storage_path}
              videoUrl={videoUrl}
            />
          );
        })}

      {/* 일반 게시글 */}
      {bcListData?.results.map((item) => {
        const hasFile =
          bcListData.file_info?.bc_file &&
          String(item.idx) in bcListData.file_info.bc_file;

        const fileInfo = getFileInfo({
          file_info: bcListData.file_info,
          idx: item.idx.toString(),
          fileCategory: 'bc_list_img',
        }) as FileInfo;
        const videoUrl = resolveNewsVideo(bcListData.file_info, item.idx);

        return (
          <NewsListItem
            key={item.idx}
            bcIdx={String(item.idx)}
            status={item.status}
            type={item.type}
            writer={item.writer}
            title={item.title}
            url={{
              link: item.link,
              link_status: item.link_status,
              link_target: item.link_target,
            }}
            viewCount={item.count}
            date={item.uploaded_at}
            commentCount={item.comment_count}
            hasFile={hasFile}
            password={item.password}
            showName={false}
            showCommentCount={false}
            showViewCount={false}
            imgUrl={fileInfo.file_storage_path}
            videoUrl={videoUrl}
          />
        );
      })}
    </div>
  );
}
